"use client";

import { useEffect, useState } from "react";

const CookieConsentBanner = () => {
  const [status, setStatus] = useState<"accepted" | "rejected" | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("cookieConsent") as
        | "accepted"
        | "rejected"
        | null;
      setStatus(stored || null);
      setIsOpen(!stored);
    } catch {
      setIsOpen(true);
    }
  }, []);

  const handleChoice = (value: "accepted" | "rejected") => {
    try {
      localStorage.setItem("cookieConsent", value);
    } catch {
      // ignore
    }
    setStatus(value);
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-20 left-3 sm:bottom-4 sm:left-4 z-40">
      {isOpen && (
        <div className="w-[190px] sm:w-[210px] rounded-xl bg-white border border-cyan-100 shadow-lg px-3 py-3 text-[11px] text-gray-700">
          <p className="mb-3 leading-relaxed text-sm">
            We use cookies to improve your experience and analyze traffic.
          </p>
          <div className="flex flex-col gap-2">
            <button
              type="button"
              onClick={() => handleChoice("rejected")}
              className="w-full px-2 py-1.5 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-100 transition text-xs"
            >
              Reject
            </button>
            <button
              type="button"
              onClick={() => handleChoice("accepted")}
              className="w-full px-2.5 py-1.5 rounded-md bg-cyan-600 text-white hover:bg-cyan-700 transition text-xs font-semibold shadow-sm"
            >
              Accept
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CookieConsentBanner;

